import {Injectable} from '@angular/core';

@Injectable()
export class Constants {
  // public readonly BASE_URL: string = 'http://127.0.0.1:8000/api';
  public readonly BASE_URL: string = 'https://admin.simplifiedcoding.in/api';
}
